import React from 'react';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SaveIcon from '@mui/icons-material/Save';

const CompaniesToolbarActions = ({ tab, saving, loadingUsers, userLoadError }) => {
    const {
        cancelCompanyDraft,
        companyDraftMode,
        isCreatingCompany,
        saveCompanyDraft,
        startCompanyCreate,
    } = tab;

    if (companyDraftMode !== 'view') {
        return (
            <>
                <Button variant="outlined" onClick={cancelCompanyDraft} disabled={saving}>
                    Annuller
                </Button>
                <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={saveCompanyDraft}
                    disabled={saving || loadingUsers || Boolean(userLoadError)}
                >
                    {isCreatingCompany ? 'Opret' : 'Gem'}
                </Button>
            </>
        );
    }

    return (
        <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={startCompanyCreate}
            disabled={saving || isCreatingCompany}
        >
            Ny virksomhed
        </Button>
    );
};

export default CompaniesToolbarActions;
